import React from 'react'

import PortalModal from './PortalModal';
import Border from '../Border';
import Collapsible from 'react-collapsible';
import Dropdown from '../Dropdown';
import LinkSelect from "../LinkSelect";
import IconPickerGrid from '../IconPickerGrid';
import Toggle from '../sectioninputs/Toggle';
import General from "../../utils/General";
import LayoutEditor from "../LayoutEditor";

export default class ProductSettingsModal extends React.Component {
  constructor(props){
    super(props)
    this.defaultLayout = [
      {key: "product_image", label: "Images", position: "left"},
      {key: "description", label: "Description", position: "left"},
      {key: "metafields", label: "Metafields", position: "left"},
      {key: "title", label: "Title", position: "right"},
      {key: "price", label: "Price", position: "right"},
      {key: "variants", label: "Variants", position: "right"},
      {key: "custom_message_options", label: "Custom Message Options", position: "right"},
      {key: "subscribe_save", label: "Subscribe & Save", position: "right"},
      {key: "quantity_cart", label: "Quantity & Buttons", position: "right"},
      {key: "share_product", label: "Share Product", position: "right"},
      ...Array.from({length: 9}, (_, i) => ({
        key: `storefront_detail_${i + 1}`,
        label: `Detail ${i + 1}`,
        position: "row"
      }))
    ];
    this.state = {
      show: props.show,
      layoutOrder: this.getInitialLayout(props),
      data: props.website.extra?.product_page_settings || {
        checkout_url: "",
        color_picker_style: "square",
        variant1_style: "btn_horizontal",
        variant2_style: "btn_horizontal",
        variant3_style: "btn_horizontal",
        product_page_count: 18,
        column_no: 3,
        meta_field_type: "tabs",
        collapsible_list_open_icon: "fa-plus fas",
        collapsible_list_close_icon: "fa-minus fas",
        collapsible_list_toggle: true,
        column_width: "standard",
        img_tile_position: "right",
        img_only_aspect_ratio: "default",
        display_variant_tile_price: false,
        autoplay_carousel_toggle: false,
        showResetLayoutModal: false
      }
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState({
      ...nextProps,
      layoutOrder: this.getInitialLayout(nextProps)
    });
  }

  getInitialLayout = (props) => {
    return props.website.extra?.product_page_settings?.layoutOrder || this.defaultLayout;
  };
  handleLayoutUpdate = (layoutOrder) => {
    const {data} = this.state;
    if (!data) {
      return;
    }

    data.layoutOrder = layoutOrder;
    this.setState({layoutOrder}, () => {
      this.props.onUpdated(data);
      setTimeout(() => General.updateAll(), 300);
    });
  };

  _renderLayoutPreviewUI() {
    return (
      <LayoutEditor
        layout={this.state.layoutOrder}
        onChange={this.handleLayoutUpdate}
        defaultLayout={this.defaultLayout}
        onReset={() => {
          this.setState({showResetLayoutModal: true});
        }}
      />
    );
  }

  handleToggle = (checked) => {
    let { data } = this.state;
    data.autoplay_carousel_toggle = checked;
    const slider = window.flickityStore.mainSlider;
    if (!slider) return;
  
    checked ? slider.playPlayer() : slider.stopPlayer();
    this.props.onUpdated(data);
  };

  _renderColorType(){
    let { data } = this.state
    let OPTIONS = [
      {
        value: "dropdown",
        label: "Dropdown Menu"
      },
      {
        value: "square",
        label: "Square Swatches"
      },
      {
        value: "circular",
        label: "Circular Swatches"
      },
      {
        value: "square_titles",
        label: "Square Swatches With Titles"
      },
      {
        value: "circular_titles",
        label: "Circular Swatches With Titles"
      },
      {
        value: "tiles",
        label: "Tiles"
      },
    ]
    return (
      <Border>
        <Collapsible
          trigger="Color Swatches"
        >
          <br/>
          <span>What style of color swatches would you like</span>
          <Dropdown
            options={OPTIONS}
            value={OPTIONS.find(
              (mode) => mode.value == data.color_picker_style
            )}
            onChange={option => {
              data.color_picker_style = option.value
              this.props.onUpdated(data)
            }}
            placeholder="Select An Option"
          />
        </Collapsible>
      </Border>
    )
  }

  _renderImageOnlyTileAspectRatioOptions(){
    let { data } = this.state
    let OPTIONS = [
      {
        value: "",
        label: "Default"
      },
      {
        value: "img-tile-ratio img-tile-ratio-1x1",
        label: "1x1"
      },
      {
        value: "img-tile-ratio img-tile-ratio-4x3",
        label: "4x3"
      },
      {
        value: "img-tile-ratio img-tile-ratio-16x9",
        label: "16x9"
      },
      {
        value: "img-tile-ratio img-tile-ratio-21x9",
        label: "21x9"
      }
    ]
    return (
      <>
        <span>Aspect Ratio</span>
        <Dropdown
          options={OPTIONS}
          value={OPTIONS.find(
            (mode) => mode.value == (data.img_only_aspect_ratio || "default")
          )}
          onChange={option => {
            data.img_only_aspect_ratio = option.value
            this.props.onUpdated(data)
          }}
          placeholder="Select An Option"
        />
      </>
    )
  }

  _renderImageTileVariantOptions(){
    let { data } = this.state
    let OPTIONS = [
      {
        value: "left",
        label: "Left"
      },
      {
        value: "right",
        label: "Right"
      },
      {
        value: "top",
        label: "Top"
      },
      {
        value: "img-only",
        label: "Image Only"
      }
    ]
    return (
      <>
        <span>Image Position</span>
        <Dropdown
          options={OPTIONS}
          value={OPTIONS.find(
            (mode) => mode.value == (data.img_tile_position || "right")
          )}
          onChange={option => {
            data.img_tile_position = option.value
            this.props.onUpdated(data)
          }}
          placeholder="Select An Option"
        />
        {data.img_tile_position === "img-only" && this._renderImageOnlyTileAspectRatioOptions()}
      </>
    )
  }
  
  _renderVariantTilePriceDisplaySettings(){
    let { data } = this.state 
    return (
      <>
        <Border>
          <Collapsible
            trigger={'Variant Tile Price'}
          >
            <br/>
            <span>Display prices on the last variant option when the variant type is set to "Button Vertical" and "Button Horizontal"</span>
            <Toggle
              id="toggle_variant_tile_price"
              checked={data.display_variant_tile_price}
              title="Display Prices On Variant Tile"
              onChange={checked => {
                data.display_variant_tile_price = checked
                this.props.onUpdated(data)
              }}
            />
          </Collapsible>
        </Border>
      </>
    )
  }

  _renderVariantType(value, imgTileVariantType){
    let { data } = this.state

    let key = `variant${value}_style`

    let OPTIONS = [
      {
        value: "dropdown",
        label: "Dropdown Menu"
      },
      {
        value: "btn_horizontal",
        label: "Button Horizontal"
      },
      {
        value: "btn_vertical",
        label: "Button Vertical"
      }
    ]
    
    const imageTileVariantOptionSelected = imgTileVariantType === key

    if (imageTileVariantOptionSelected || !imgTileVariantType) {
      OPTIONS.push({
        value: "img_tile",
        label: "Image Tile"
      })
    }
    return (
      <Border>
        <Collapsible
          trigger={`Variant ${value} Type`}
        >
          <br/>
          <span>What style of variant {value} would you like</span>
          <Dropdown
            options={OPTIONS}
            value={OPTIONS.find(
              (mode) => mode.value == data[key]
            )}
            onChange={option => {
              data[key] = option.value
              this.props.onUpdated(data)
            }}
            placeholder="Select An Option"
          />
          {imageTileVariantOptionSelected && this._renderImageTileVariantOptions()}
        </Collapsible>
      </Border>
    )
  }

  _checkoutPage() {
    let { data } = this.state

    return (
      <Border>
        <Collapsible
          trigger={`Checkout Page`}
        >
          <br/>
          <span>Link your checkout page</span>
          <LinkSelect
            type={"shop"}
            checkoutOnly={true}
            url={data.checkout_url}
            onUpdated={(url) => {
              data.checkout_url = url
              this.props.onUpdated(data)
            }}
          />
        </Collapsible>
      </Border>
    )
  }

  _renderAccordionIcons(iconTitle, iconKey) {
    const { data } = this.state
    return <>
      <span>{iconTitle}</span>
      <Collapsible trigger={iconTitle} className="mb-3">
        <br />
        <div className="row no-gutters align-items-center">
          <div className="col-auto">Current Icon : </div>
          <div className="col-auto pl-2">
            {
              data[iconKey] ?
                <>
                  <i
                    className={`${data[iconKey]}`}
                    style={{fontSize: 30}}
                  />
                </>
                :
                <>
                  <i className="stack-interface stack-menu" style={{fontSize: 30}}></i>
                </>
              }
          </div>
        </div>
        <div className="button-icon-picker mt-4">
          <IconPickerGrid
            columnWidth={110}
            className=""
            width={356}
            rowHeight={110}
            onSelected={(icon) => {
              if (icon.icon.startsWith("fa-")) {
                data[iconKey] = icon.icon
                this.props.onUpdated(data)
              } else {
                data[iconKey] = `icon icon--lg icon-${icon.name}`
                this.props.onUpdated(data)
              }
            }}
          />
        </div>
      </Collapsible>
    </>
  }

  _renderMetaFieldsSettings() {
    const { data } = this.state
    const OPTIONS = [
      {
        value: "tabs",
        label: "Tabs"
      },
      {
        value: "collapsible-list",
        label: "Collapsible List"
      }
    ]
    return (
      <Border>
        <Collapsible
          trigger="Metafields"
        >
          <br/>
          <span>Type</span>
          <Dropdown
            options={OPTIONS}
            value={OPTIONS.find(
              (mode) => mode.value === data.meta_field_type
            )}
            onChange={option => {
              data.meta_field_type = option.value
              this.props.onUpdated(data)
            }}
            placeholder="Select An Option"
          />
          {data.meta_field_type === "collapsible-list" && <>
            { this._renderAccordionIcons("Open Icon", "collapsible_list_open_icon") }
            { this._renderAccordionIcons("Close Icon", "collapsible_list_close_icon") }
            <Toggle
              id="toggle_collapsible_list"
              checked={data.collapsible_list_toggle}
              title="Toggle List"
              onChange={checked => {
                data.collapsible_list_toggle = checked
                this.props.onUpdated(data)
              }}
            />
          </>}
        </Collapsible>
      </Border>
    )
  }

  _displaySettings() {
    let { data } = this.state
    let OPTIONS = [
      {
        value: "standard",
        label: "Standard"
      },
      {
        value: "even",
        label: "Even"
      }
    ]
    return (
      <Border>
        <Collapsible
          trigger={"Display Settings"}
        >
          <br/>
          <span>Column Width</span>
          <Dropdown
            options={OPTIONS}
            value={OPTIONS.find(
              (mode) => mode.value === (data.column_width || "standard")
            )}
            onChange={option => {
              data.column_width = option.value
              this.props.onUpdated(data)
            }}
            placeholder="Select An Option"
          />
          <br/>
          <br/>
          <Toggle
            id="autoplayToggle"
            title="Autoplay Carousel"
            checked={data?.autoplay_carousel_toggle}
            onChange={this.handleToggle}
          />
        </Collapsible>
      </Border>
    )
  }

  _checkoutType() {
    let { data } = this.state

    let OPTIONS = [
      {
        value: "instant",
        label: "Instant Checkout"
      },
      {
        value: "cart",
        label: "Cart Based Checkout"
      },
      {
        value: "instantAndCart",
        label: "Instant and Cart Based Checkout"
      }
    ]
    return (
      <Border>
        <Collapsible
          trigger={`Checkout Experience`}
        >
          <br/>
          <span>What checkout experience would you prefer</span>
          <Dropdown
            options={OPTIONS}
            value={OPTIONS.find(
              (mode) => mode.value === this.props.website.checkout_type
            )}
            onChange={option => {
              this.props.onCheckoutTypeUpdated(option.value)
            }}
            placeholder="Select An Option"
          />
        </Collapsible>
      </Border>
    )
  }

  _productsPerPage() {
    let { data } = this.state

    let OPTIONS = [
      {
        value: 6,
        label: "6 Products"
      },
      {
        value: 12,
        label: "12 Products"
      },
      {
        value: 18,
        label: "18 Products"
      },
      {
        value: 24,
        label: "24 Products"
      }
    ]

    let productPageCount = data.product_page_count || 18

    return (
      <Border>
        <Collapsible
          trigger={`# of Products Per Page`}
        >
          <br/>
          <span>The number of products to display</span>
          <Dropdown
            options={OPTIONS}
            value={OPTIONS.find(
              (mode) => mode.value === productPageCount
            )}
            onChange={option => {
              data.product_page_count = option.value
              this.props.onUpdated(data)
            }}
            placeholder="Select An Option"
          />
        </Collapsible>
      </Border>
    )
  }

  _noOfColumns() {
    let { data } = this.state

    let OPTIONS = [
      {
        value: 2,
        label: "2 Columns"
      },
      {
        value: 3,
        label: "3 Columns"
      },
      {
        value: 4,
        label: "4 Columns"
      }
    ]

    let columnNo = data.columns_no || 3

    return (
      <Border>
        <Collapsible
          trigger={`# of Columns`}
        >
          <br/>
          <span>The number of columns to display</span>
          <Dropdown
            options={OPTIONS}
            value={OPTIONS.find(
              (mode) => mode.value === columnNo
            )}
            onChange={option => {
              data.column_no = option.value
              this.props.onUpdated(data)
            }}
            placeholder="Select An Option"
          />
        </Collapsible>
      </Border>
    )
  }

  _renderResetLayoutModal() {
    return (
      <PortalModal
        show={this.state.showResetLayoutModal}
        showAsSideMenu="false"
        onHide={() => this.setState({showResetLayoutModal: false})}
      >
        <div className="modal-share">
          <div className="modal-head">
            <h2 className="mb-0">Reset Layout</h2>
          </div>

          <div className="row modal-body">
            <div className="col-md-12">
              <h4>Are you sure you want to reset the layout to its default configuration?</h4>
            </div>
          </div>

          <div className="text-right modal-footer">
            <a
              className="btn type--uppercase"
              onClick={() => this.setState({showResetLayoutModal: false})}
            >
            <span className="btn__text">
              Cancel
            </span>
            </a>
            <a
              className="btn btn--primary type--uppercase"
              style={{
                background: "#fa6160",
                borderColor: "#fa6160"
              }}
              onClick={() => {
                this.setState({showResetLayoutModal: false});
                this.handleLayoutUpdate(this.defaultLayout);
              }}
            >
            <span className="btn__text">
              Reset Layout
            </span>
            </a>
          </div>
        </div>
      </PortalModal>
    );
  }

  render() {
    let {
      show,
      data
    } = this.state

    const productPage = window.location.pathname.includes("/product")

    let imgTileVariantType = ""

    const variantTypeIndexes = [1, 2, 3]

    variantTypeIndexes.forEach((item) => {
      const key = `variant${item}_style`
      if (data[key] === "img_tile") {
        imgTileVariantType = key
      }
    })

    const title = productPage ? "product" : "collection"

     return (
      <PortalModal
        show={show}
        loadSideMenuFromLeft="true"
        onHide={() => this.props.onHide()}
        disableBodyScroll={true}
      >
        <h2 className="mb-0">
          {General.toTitleCase(title)} Page Settings
        </h2>
        <label className="mb-5">Adjust your {title} page core style</label>

        {
          productPage &&
          <>
            {this._renderLayoutPreviewUI()}

            {this._displaySettings()}

            {this._checkoutType()}

            {this._checkoutPage()}

            {this._renderVariantTilePriceDisplaySettings()}

            {this._renderColorType()}

            {this._renderVariantType(1, imgTileVariantType)}

            {this._renderVariantType(2, imgTileVariantType)}

            {this._renderVariantType(3, imgTileVariantType)}

            {this._renderMetaFieldsSettings()}

            {this._renderResetLayoutModal()}
          </>
        }

        {
          !productPage &&
          <>
            {this._checkoutType()}

            {this._checkoutPage()}

            {this._productsPerPage()}

            {this._noOfColumns()}
          </>
        }


      </PortalModal>
    )
  }
}
